import Grid from "@mui/material/Grid2";
import { FormGroup } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import { Fragment, ReactNode } from "react";
import type { AgreementDetailsByTypeProps } from "view/agreements/schema/schema";


type DetailsField = {
	id: string;
	render: () => ReactNode;
}

const RentAgreementDetails = ({ agreement, hiddenFields }: AgreementDetailsByTypeProps) => {

	const RentAgreementDetailsFields: DetailsField[] = [
		{
			id: "agreement.availableHoursADay",
			render: () => (
				<Grid size={4}>
					<FormGroup label={intl.formatMessage({ id: "SHIP_AVAILABLE_HOURS_A_DAY" })} overflow="hidden">
						{agreement.shipAvailability?.availableHoursADay}
					</FormGroup>
				</Grid>
			),
		},
		{
			id: "agreement.declarationMonthTerm",
			render: () => (
				<Grid size={4}>
					<FormGroup label={intl.formatMessage({ id: "DECLARATION_MONTH_TERM" })} overflow="hidden">
						{agreement.declarationMonthTerm && intl.formatMessage({ id: `DECLARATION_MONTH_TERM_${agreement.declarationMonthTerm}` })}
					</FormGroup>
				</Grid>
			),
		},
	];

	return (
		<>
			{RentAgreementDetailsFields
				.filter(x => !hiddenFields?.includes(x.id))
				.map(x => (
					<Fragment key={x.id}>
						{x.render()}
					</Fragment>
				))
			}
		</>
	);
};

export default RentAgreementDetails;
